import DocxModal from './DocxModal'
export default DocxModal
